'use strict';
var base = require('base/components/focus');
var FOCUSABLE = 'a[href], area[href], object:not([disabled]), :input:not([disabled]), [tabindex]';
var FILTER = ':visible:not([tabindex=-1])';

var getFocusableElements = function (context) {
    return context ? $(context).find(FOCUSABLE).filter(FILTER) : $(FOCUSABLE).filter(FILTER);
};

var focus = {
    trapModalFocus: function (selector) {
        var TABKEYCODE = 9;

        $('body').on('keydown', selector, function (e) {
            var isTabPressed = (e.key === 'Tab' || e.keyCode === TABKEYCODE);

            if (!isTabPressed) {
                return;
            }

            var focusableEls = getFocusableElements($(selector));
            var firstFocusableEl = focusableEls.first()[0];
            var lastFocusableEl = focusableEls.last()[0];

            if (e.shiftKey) /* shift tab keypress */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        });
    },

    focusFirstModalElementOnOpen: function () {
        $('body').on('shown.bs.modal', '.modal', function () {
            // Store identifier for currently focused element, so we can return focus later
            var focusID = 'modal-' + Date.now();
            $(document.activeElement).attr('data-opened-by', focusID);
            $(this).data('focus-id', focusID);

            getFocusableElements(this).first().focus();
        });
    },

    returnFocusOnModalClose: function () {
        $('body').on('hide.bs.modal', '.modal', function () {
            var focusID = $(this).data('focus-id');

            if (focusID) {
                $('[data-opened-by="' + focusID + '"]').focus();
            }
        });
    },

    focusElement: function (index, context) {
        var focusableEls = getFocusableElements(context);
        focusableEls.eq(index).focus();
    },

    getFocusIndex: function (element, context) {
        var focusableEls = getFocusableElements(context);
        return focusableEls.index(element);
    }
};

module.exports = $.extend(base, focus);
